import React, {useState, useEffect, useRef} from "react";
import { useSearchParams } from "react-router-dom";
import StudentPageHeader from "./StudentPageHeader";
import TabNavigation from "../features/common/TabNavigation";
import StudentDashboard from "./Dashboard/StudentDashboard";
import StudentInterview from "./Interview/StudentInterview";
import StudentProgess from "./Progress/StudentProgess";
import {
  getActiveInterview,
  getAllActiveInterviews,
  getCompletedInterviews
} from "../../application/services/studentDashboard";
import {
  setActiveInterview,
  setUpcomingInterviews,
  setCompletedInterviews,
} from "../../store/studentPageReducer"
import {useDispatch, useSelector} from "react-redux";

const VALID_TAB_IDS = ["dashboard", "Interviews", "Progress"];

const StudentPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const initialTab = VALID_TAB_IDS.includes(tabFromUrl) ? tabFromUrl : "dashboard";
  const [activeTab, setActiveTab] = useState(initialTab);
  const dispatch = useDispatch();

  useEffect(() => {
    if (VALID_TAB_IDS.includes(tabFromUrl) && tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setSearchParams({ tab: tabId }, { replace: true });
  };
  const fetchingRef = useRef(false);
  const { user } = useSelector((state) => state.login.student);
  const email = user?.email || "";
  
  const userDetail = {
    student_name: user?.name || user?.student_name || "Student",
    student_email:  email
  };

  useEffect(() => {
    if (!email) {
      return;
    }
    if (fetchingRef.current) {
      return;
    }
    
    fetchingRef.current = true;
    
    const loadDashboardData = async () => {
      const [active, upcoming, completed] = await Promise.allSettled([
        getActiveInterview(email),
        getAllActiveInterviews(email, 1, 6),
        getCompletedInterviews(email, 1, 5),
      ]);

      if (active.status === "fulfilled") {
        try {
          dispatch(setActiveInterview(active.value?.data || null));
        } catch (error) {
          console.error("Error processing active interview:", error);
        }
      } else {
        console.error("Error fetching active interview:", active.reason);
      }

      if (upcoming.status === "fulfilled") {
        try {
          const upcomingData = upcoming.value?.data?.data || upcoming.value?.data || [];
          dispatch(setUpcomingInterviews(upcomingData));
        } catch (error) {
          console.error("Error processing upcoming interviews:", error);
        }
      } else {
        console.error("Error fetching upcoming interviews:", upcoming.reason);
      }

      if (completed.status === "fulfilled") {
        try {
          const completedData = completed.value?.data?.data || completed.value?.data || [];
          dispatch(setCompletedInterviews(completedData));
        } catch (error) {
          console.error("Error processing completed interviews:", error);
        }
      } else {
        console.error("Error fetching completed interviews:", completed.reason);
      }
    };
    
    loadDashboardData().finally(() => {
      fetchingRef.current = false;
    });
  }, [dispatch, email]);

  const tabs = [
    { id: "dashboard", label: "Dashboard", icon: "barChart3", content: <StudentDashboard/> },
    { id: "Interviews", label: "Interviews", icon: "chatIcon", content: <StudentInterview/> },
    { id: "Progress", label: "Progress", icon: "trendingUp", content: <StudentProgess/> },
  ]
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="fixed top-4 right-4 z-50">
      </div>
      <StudentPageHeader userDetail={userDetail}/>
      <div className="max-w-7xl mx-auto p-6">
        <div className="bg-white rounded-lg border border-gray-200 mb-6">
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabClick={handleTabClick}
        />
      </div>
        <div className="space-y-6">
            {tabs.find((t) => t.id === activeTab)?.content}
        </div>
      </div>
    </div>
  );
};
export default StudentPage;
